import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { horizontalGutterSpace, backgroundColor, shadowSize, borderRadiusSize } from "./settings";
export var PriceToggleWrapper = styled.div.withConfig({
  componentId: "sc-2b6inx-0"
})(["display:flex;justify-content:flex-end;margin-bottom:", ";", "{margin-bottom:", ";}"], space(4), breakpoint("medium"), unit(34));
export var MainContentContainer = styled.div.withConfig({
  componentId: "sc-2b6inx-1"
})(function (_ref) {
  var $hasSubItems = _ref.$hasSubItems,
    theme = _ref.theme;
  return css(["", "{border-radius:", ";", " ", "{box-shadow:", ";}}"], breakpoint("small", "medium"), getBorderRadius(theme, borderRadiusSize), $hasSubItems && css(["border-bottom-left-radius:0;border-bottom-right-radius:0;"]), breakpoint("medium"), getBoxShadow(theme, shadowSize));
});
export var Content = styled.div.withConfig({
  componentId: "sc-2b6inx-2"
})(function (_ref2) {
  var $hasSubItems = _ref2.$hasSubItems,
    $hasAdditionalInfo = _ref2.$hasAdditionalInfo,
    $hasBottomContainer = _ref2.$hasBottomContainer,
    theme = _ref2.theme;
  return css(["position:relative;padding:", " ", " ", " ", ";background-color:", ";border-top-right-radius:", ";border-top-left-radius:", ";", "{align-items:center;margin-bottom:0;padding:", " ", " ", " ", ";}", " ", " ", ""], space(4), space(3), space(3), space(3), getColor(theme, backgroundColor), getBorderRadius(theme, borderRadiusSize), getBorderRadius(theme, borderRadiusSize), breakpoint("medium"), space(5), space(3), space(5), space(3), $hasAdditionalInfo ? css(["padding-bottom:", " !important;"], space(3)) : null, $hasBottomContainer ? css(["padding-bottom:", " !important;"], space(2)) : null, !$hasSubItems && css(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";box-shadow:", ";"], getBorderRadius(theme, borderRadiusSize), getBorderRadius(theme, borderRadiusSize), getBoxShadow(theme, shadowSize)));
});
export var MainContent = styled.div.withConfig({
  componentId: "sc-2b6inx-3"
})(["", "{display:grid;grid-gap:", ";grid-template-columns:auto 1fr auto;align-items:center;}"], breakpoint("medium"), space(horizontalGutterSpace));
export var SubItems = styled.div.withConfig({
  componentId: "sc-2b6inx-4"
})(["margin-top:", ";"], unit(2));
export var HeaderContainer = styled.div.withConfig({
  componentId: "sc-2b6inx-5"
})(["position:absolute;bottom:calc(100% - ", ");", "{bottom:calc(100% - ", ");}"], unit(16), breakpoint("medium"), unit(18));